export default __webpack_public_path__ + "static/media/nsLong419.4ddc6585.png";